// Browser push: service worker registration (all pages) and the settings
// panel wiring. External file, not inline — the CSP allows only 'self'
// scripts, which is why this cannot live in a <script> tag.

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js').catch(() => {})
}

function b64ToBytes(base64) {
  const padding = '='.repeat((4 - (base64.length % 4)) % 4)
  const raw = atob((base64 + padding).replace(/-/g, '+').replace(/_/g, '/'))
  return Uint8Array.from(raw, (c) => c.charCodeAt(0))
}

function wireSettings() {
  const box = document.getElementById('push-settings')
  if (!box || box.dataset.wired) return
  box.dataset.wired = '1'

  const enableBtn = document.getElementById('push-enable')
  const disableBtn = document.getElementById('push-disable')
  const status = document.getElementById('push-status')
  const csrf = document.querySelector('meta[name="csrf-token"]')?.content

  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    // Honest instead of blank: iPhone Safari only exposes push to sites
    // installed on the home screen.
    status.textContent = /iPhone|iPad/.test(navigator.userAgent)
      ? 'On iPhone and iPad, notifications need the island installed first: Share → Add to Home Screen, then enable from the installed app.'
      : 'This browser does not support notifications.'
    return
  }

  const show = (sub) => {
    enableBtn.style.display = sub ? 'none' : 'inline-block'
    disableBtn.style.display = sub ? 'inline-block' : 'none'
  }

  // getRegistration resolves immediately (unlike .ready, which can hang
  // forever if registration failed) — the buttons must always appear.
  navigator.serviceWorker.getRegistration()
    .then((reg) => (reg ? reg.pushManager.getSubscription() : null))
    .then(show)
    .catch(() => show(null))

  enableBtn.addEventListener('click', () => {
    Notification.requestPermission().then((permission) => {
      if (permission !== 'granted') {
        status.textContent = 'Notifications are blocked for this site in your browser settings.'
        return
      }
      navigator.serviceWorker.register('/service-worker.js')
        .then((reg) => navigator.serviceWorker.ready)
        .then((reg) => reg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: b64ToBytes(box.dataset.vapid),
        }))
        .then((sub) => fetch('/push_subscriptions', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf },
          body: JSON.stringify({ endpoint: sub.endpoint, keys: sub.toJSON().keys }),
        }).then(() => {
          show(sub)
          status.textContent = 'On — this browser will get island notifications.'
        }))
        .catch(() => { status.textContent = 'Could not enable notifications in this browser.' })
    })
  })

  disableBtn.addEventListener('click', () => {
    navigator.serviceWorker.getRegistration()
      .then((reg) => (reg ? reg.pushManager.getSubscription() : null))
      .then((sub) => {
        if (!sub) { show(null); return null }
        return fetch('/push_subscriptions', {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf },
          body: JSON.stringify({ endpoint: sub.endpoint }),
        }).then(() => sub.unsubscribe()).then(() => {
          show(null)
          status.textContent = 'Off for this browser.'
        })
      })
  })
}

document.addEventListener('turbo:load', wireSettings)
document.addEventListener('DOMContentLoaded', wireSettings)
